import $ from "jquery";
import { csl, u_ } from "@pressmedia/webappbase";

export default {
	/*----------------
	* フォームの中身の生成
	**/
	async initForm() {
		if(!this.config) {
			csl.warn(this.getAddress(), "The config object isn't loaded yet.");
			return this;
		}
		
		if( !u_.isObject(this.config.sheet) ) {
			csl.warn(this.getAddress(), "This config has no sheet.");
			return this;
		}
		
		if( !u_.isObject(this.config.dataParams) ) {
			csl.warn(this.getAddress(), "This config has no dataParams.");
			return this;
		}
		
		if(!this.$self) {
			return this;
		}
		
		await this._promise;
		this._initAutoInps()._initSheets();
			
			// wysiwyg
		if( Array.isArray(this.wysiwyg.params) && this.wysiwyg.params.has ) {
			this.wysiwyg.params._map = {};
			this.wysiwyg.params.forEach(pk => {
				let vuw = this.find(pk).get(0);
				!!vuw && ( vuw = vuw.get("field") );
				!!vuw && (this.wysiwyg.params._map[pk] = vuw);
			});
		}
			
		await Promise.all( this.getChildren().map(vuw => vuw.getReady()) );
		
		this.setActiveSheet(0);
		
		return this;
	},
	
	/*----------------
	* hidden項目の生成
	**/
	_initAutoInps() {
		const $autoInps = $.fn.append.apply(
			$("<p/>").addClass("auto-inps"),
			["sheet"].map(name => $("<input/>").attr({
				type: "hidden",
				name: name
			}))
		);
		
		this.$autoInps = $autoInps.appendTo(this.$self).hide();
		return this;
	},
	
	/*----------------
	* config.dataParamsからVuwSheetを生成
	**/
	_initSheets() {
		// [add input sheets]
		const keys = Object.keys(this.config.sheet);
		const lastIdx = keys.length - 1;
		keys.forEach((sheetName, i) => {
			const prop = this.getDefaultSheetProp(sheetName);
			
			// 最初のシートについては戻るボタンは不要
			(!i && prop.btns.prev) && (delete prop.btns.prev);
			
			if(!this.confirmSheetName && i === lastIdx) {
				// confirmなしで最後のシートの場合
				prop.renderComplete = $self => {
					// execボタン
					const $btn = $self.find(".btn-next").addClass("btn-exec");
					if(u_.isObject(this.config.btnText) && this.config.btnText.exec) {
						$btn.children("span").html( $.parseHTML(this.config.btnText.exec) );
					}
				};
			}
			
			this.add(sheetName, prop);
		});
		
		// [add confirm sheet]
		!!this.confirmSheetName && this.add(
			this.confirmSheetName,
			this.getDefaultSheetProp("confirm"),
			function() {
				// コピー先用Vuwを登録
				Object.keys(this.container.config.sheet).forEach((sheetName, i) => {
					this.add(sheetName, this.childProp);
				});
			}
		);
		
		// [add finish sheet]
		!!this.finishSheetName && this.add(
			this.finishSheetName,
			this.getDefaultSheetProp("finish")
		);
		
		return this;
	}
};
